/*
  abeauty-pdp.js (2026-10-02, corectie 3.10.2026)

  Pagina de produs fara clinica preselectata (Etapa 1) + bara fixa de cumparare pe mobil (Etapa 2).

  Serverul (product-variant-picker.liquid) pune un placeholder „Alege clinica" /
  „Alege zona" in fiecare select cand URL-ul nu are ?variant=, iar buy-buttons.liquid
  lasa id-ul variantei gol si butonul dezactivat. Scriptul de aici:

  1. Asculta `change` in faza de capture pe <product-info>, INAINTEA handlerului
     Dawn din <variant-selects>. Cat timp mai exista un select pe placeholder,
     opreste propagarea: Dawn nu mai cere sectiunea cu doar o parte din optiuni
     (Shopify ar completa singur optiunile lipsa, de ex. prima zona, si ar activa
     butonul cu o varianta pe care clientul n-a ales-o). Cand toate optiunile sunt
     alese, evenimentul trece mai departe si Dawn face ce facea si inainte: pret,
     buton, URL cu ?variant=.
  2. Muta atributul `selected` pe optiunea aleasa (Dawn citeste `option[selected]`,
     nu `select.value`), ca la urmatoarea alegere cererea sa plece cu id-urile bune.
  3. Blocheaza submit-ul formularului de adaugare in cos cat timp selectia e
     incompleta si duce focusul pe primul select ramas pe placeholder.
  4. Anunta bara fixa de pe mobil prin evenimentul `abeauty:selectie`.
  5. Bara fixa (snippets/abeauty-pdp-sticky.liquid, randata din layout): apare cand
     butoanele de cumparare nu sunt in viewport; eticheta urmareste selectia; click =
     deruleaza la selectul ramas pe placeholder sau trimite formularul; pretul se
     actualizeaza din `variantChange` al lui Dawn.

  Se initializeaza pe toate <product-info> existente si pe cele incarcate ulterior
  (quick-add-ul din colectii trimite `product-info:loaded`).
*/
(function () {
  'use strict';

  var LABEL_FALLBACK = 'Alege clinica';
  var LABEL_BUY = 'Cumpără';

  function selectsOf(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('variant-selects select'));
  }

  function incompleteSelect(scope) {
    var sels = selectsOf(scope);
    for (var i = 0; i < sels.length; i++) {
      if (sels[i].value === '') return sels[i];
    }
    return null;
  }

  /* 3.10.2026: id-urile de optiune se citesc din SELECTIE, nu din atributul `selected`.
     Dawn (VariantSelects.updateSelectionMetadata) muta atributul scotandu-l intai de pe
     optiunea veche; in WebKit (Safari si Chrome pe iPhone) acea stergere reseteaza selectul
     pe prima optiune activa, adica Bucuresti Tei, si cererea de sectiune pleca cu clinica
     gresita. De aceea evenimentul de selectie se publica de aici, iar handlerul Dawn nu
     mai primeste `change` (stopPropagation in faza de capture). */
  function selectedOptionValueIds(scope) {
    var ids = [];
    selectsOf(scope).forEach(function (s) {
      var o = s.options[s.selectedIndex];
      if (o && o.value !== '' && o.dataset && o.dataset.optionValueId) ids.push(o.dataset.optionValueId);
    });
    Array.prototype.forEach.call(scope.querySelectorAll('variant-selects fieldset input:checked'), function (i) {
      if (i.dataset && i.dataset.optionValueId) ids.push(i.dataset.optionValueId);
    });
    return ids;
  }

  function publishSelection(scope, event, chosen) {
    if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.optionValueSelectionChange) {
      return false;
    }
    publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
      data: { event: event, target: chosen, selectedOptionValues: selectedOptionValueIds(scope) },
    });
    return true;
  }

  function submitButton(scope) {
    return scope.querySelector('.product-form__submit');
  }

  function labelFor(select, button) {
    if (select && select.dataset && select.dataset.abChooseLabel) return select.dataset.abChooseLabel;
    return (button && button.dataset && button.dataset.abLabelClinic) || LABEL_FALLBACK;
  }

  function lockButton(scope, label) {
    var btn = submitButton(scope);
    if (!btn) return;
    btn.setAttribute('disabled', 'disabled');
    var span = btn.querySelector('span');
    if (span && label) span.textContent = label;
  }

  function emit(scope, complete, label) {
    try {
      document.dispatchEvent(
        new CustomEvent('abeauty:selectie', {
          detail: { complete: complete, label: label || null, scope: scope },
        })
      );
    } catch (e) {
      /* browsere vechi fara CustomEvent: bara fixa ramane pe starea initiala */
    }
  }

  /* 2026-10-19: la produsele cu livrare, plata rapidă (buy-buttons.liquid, [data-ab-plata-variante])
     apare doar după ce toate opțiunile sunt alese; altfel id-ul variantei e gol. */
  document.addEventListener('abeauty:selectie', function (e) {
    var scope = e.detail && e.detail.scope;
    if (!scope || !scope.querySelectorAll) return;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-ab-plata-variante]'), function (el) {
      el.hidden = !e.detail.complete;
    });
  });

  function onChange(scope, event) {
    var target = event.target;
    if (!target || target.tagName !== 'SELECT') return;
    if (!target.closest || !target.closest('variant-selects')) return;
    var chosen = target.options[target.selectedIndex];
    var missing = incompleteSelect(scope);
    if (!missing) {
      emit(scope, true, null);
      /* selectia e completa: cererea de sectiune pleaca de aici, cu id-urile din selectie;
         daca pubsub-ul Dawn lipseste, evenimentul trece mai departe ca inainte */
      if (chosen && publishSelection(scope, event, chosen)) event.stopPropagation();
      return;
    }
    event.stopPropagation();
    var label = labelFor(missing, submitButton(scope));
    lockButton(scope, label);
    emit(scope, false, label);
    pretZona(scope);
  }

  function onSubmit(scope, event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
    var missing = incompleteSelect(scope);
    if (!missing) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    var label = labelFor(missing, submitButton(scope));
    lockButton(scope, label);
    var productForm = scope.querySelector('product-form');
    if (productForm && typeof productForm.handleErrorMessage === 'function') {
      productForm.handleErrorMessage(label + ' înainte de a adăuga în coș.');
    }
    missing.focus();
    if (missing.scrollIntoView) missing.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  /* ------------------------------------------------------------ zona din link + prețul zonei (4.11.2026)
     Oferte pe zone: cardurile „Alege zona” trimit la /products/<handle>?zona=<valoare>. Fără ?variant=,
     zona se alege aici, clinica rămâne pe „Alege clinica” (fără clinică implicită). Linkurile fără ?zona= nu se schimbă.
     Când zona e aleasă și clinica nu, prețul arăta „De la X” (prima zonă ieftină). Acum: dacă zona are ACELAȘI preț și
     barat în toate clinicile (din /products/<handle>.js), cerem secțiunea temei pentru o clinică disponibilă cu zona aleasă
     și înlocuim DOAR blocul de preț (markup-ul temei, cu barat/pastilă). Selecția, butonul și URL-ul rămân neatinse.
     Dacă prețul diferă între clinici sau orice pas eșuează, rămâne prețul de dinainte. */
  var produsJs = {};
  function incarcaProdus(url) {
    if (!produsJs[url]) {
      produsJs[url] = fetch(url.split('?')[0] + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    }
    return produsJs[url];
  }

  function esteClinica(select) { return /clinic/i.test(select.name || ''); }

  function pretZona(scope) {
    var sels = selectsOf(scope);
    var zonaSel = null, clinicaSel = null;
    sels.forEach(function (s) { if (esteClinica(s)) clinicaSel = s; else zonaSel = s; });
    if (!zonaSel || !clinicaSel || zonaSel.value === '' || clinicaSel.value !== '') return;
    var sectiune = scope.dataset.section, url = scope.dataset.url || window.location.pathname;
    var pretEl = sectiune && document.getElementById('price-' + sectiune);
    if (!pretEl) return;
    var zona = zonaSel.value, cerere = zona;
    scope.dataset.abZonaPret = cerere;
    incarcaProdus(url).then(function (prod) {
      if (!prod || !prod.variants || scope.dataset.abZonaPret !== cerere) return null;
      var iz = -1;
      (prod.options || []).forEach(function (o, i) { var n = typeof o === 'string' ? o : o.name; if (!/clinic/i.test(n)) iz = i; });
      if (iz < 0) return null;
      var vs = prod.variants.filter(function (v) { return v.options[iz] === zona; });
      if (!vs.length) return null;
      var p0 = vs[0].price, c0 = vs[0].compare_at_price || 0;
      if (!vs.every(function (v) { return v.price === p0 && (v.compare_at_price || 0) === c0; })) return null;
      var disp = vs.filter(function (v) { return v.available; })[0];
      if (!disp) return null;
      var ic = iz === 0 ? 1 : 0;
      var optClinica = Array.prototype.filter.call(clinicaSel.options, function (o) { return o.value === disp.options[ic]; })[0];
      var optZona = zonaSel.options[zonaSel.selectedIndex];
      if (!optClinica || !optZona || !optClinica.dataset.optionValueId || !optZona.dataset.optionValueId) return null;
      var ids = sels.map(function (s) { return s === clinicaSel ? optClinica.dataset.optionValueId : optZona.dataset.optionValueId; });
      return fetch(url.split('?')[0] + '?section_id=' + encodeURIComponent(sectiune) + '&option_values=' + ids.join(','), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : null; });
    }).then(function (html) {
      if (!html || scope.dataset.abZonaPret !== cerere) return;
      var nou = new DOMParser().parseFromString(html, 'text/html').getElementById('price-' + sectiune);
      if (nou && clinicaSel.value === '' && zonaSel.value === cerere) pretEl.innerHTML = nou.innerHTML;
    }).catch(function () {});
  }

  function preselecteazaZona(scope) {
    if (!scope.id || scope.id.indexOf('MainProduct-') !== 0) return;
    var q = new URLSearchParams(window.location.search);
    var zona = q.get('zona');
    if (!zona || q.get('variant')) return;
    selectsOf(scope).forEach(function (s) {
      if (esteClinica(s) || s.value !== '') return;
      for (var i = 0; i < s.options.length; i++) {
        if (s.options[i].value === zona && !s.options[i].disabled) {
          Array.prototype.forEach.call(s.options, function (o) { o.removeAttribute('selected'); });
          s.selectedIndex = i;
          s.options[i].setAttribute('selected', 'selected');
          break;
        }
      }
    });
  }

  function init(productInfo) {
    if (!productInfo || !productInfo.dataset || productInfo.dataset.abPdp === '1') return;
    productInfo.dataset.abPdp = '1';
    productInfo.addEventListener('change', function (e) { onChange(productInfo, e); }, true);
    productInfo.addEventListener('submit', function (e) { onSubmit(productInfo, e); }, true);
    preselecteazaZona(productInfo);
    var missing = incompleteSelect(productInfo);
    var label = missing ? labelFor(missing, submitButton(productInfo)) : null;
    if (missing) lockButton(productInfo, label);
    emit(productInfo, !missing, label);
    if (missing) pretZona(productInfo);
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('product-info'), init);
  }

  /* ------------------------------------------------------------ bara fixa (Etapa 2) */

  function formatLei(cents) {
    return Math.round(cents / 100) + ' lei';
  }

  /* 2026-10-18 (revizuit 19.10): iconița Consentmo (redeschide setările de cookie, stânga jos) stă în
     shadow DOM-ul lui <csm-cookie-consent> și acoperea prețul din bara fixă. N-o ascundem (retragerea
     acordului trebuie să rămână la îndemână), doar o ridicăm cât timp bara e vizibilă, pe aceeași
     plajă ca bara (sub 990px). Clasele ei sunt generate, deci o găsim o dată după poziție (element
     fix, mic, lângă marginea de jos) și o ținem minte; poziția inline a Consentmo se păstrează și se
     reface exact. */
  var MQ_BARA = '(max-width: 989px)';
  var iconitaCookie = null;
  function gasesteIconitaCookie() {
    if (iconitaCookie && iconitaCookie.isConnected) return iconitaCookie;
    var host = document.querySelector('csm-cookie-consent');
    var sr = host && host.shadowRoot;
    if (!sr) return null;
    var lista = sr.querySelectorAll('div, button, a');
    for (var i = 0; i < lista.length; i++) {
      var el = lista[i];
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed') continue;
      var r = el.getBoundingClientRect();
      if (r.width === 0 || r.width > 90 || r.height > 90 || parseFloat(cs.bottom) > 40) continue;
      el.dataset.abBottom = el.style.getPropertyValue('bottom');
      el.dataset.abBottomPrio = el.style.getPropertyPriority('bottom');
      iconitaCookie = el;
      return el;
    }
    return null;
  }
  function mutaIconitaCookie(urca) {
    var el = gasesteIconitaCookie();
    if (!el) return;
    var sus = urca && window.matchMedia(MQ_BARA).matches;
    var tinta = 'calc(80px + env(safe-area-inset-bottom))';
    if (sus) {
      if (el.style.getPropertyValue('bottom') !== tinta) el.style.setProperty('bottom', tinta, 'important');
    } else if (el.style.getPropertyValue('bottom') === tinta) {
      if (el.dataset.abBottom) el.style.setProperty('bottom', el.dataset.abBottom, el.dataset.abBottomPrio);
      else el.style.removeProperty('bottom');
    }
  }

  function initSticky() {
    var bar = document.querySelector('[data-ab-sticky]');
    if (!bar) return;
    var main = document.querySelector('product-info[id^="MainProduct-"]') || document.querySelector('product-info');
    if (!main) return;
    var btn = bar.querySelector('[data-ab-sticky-btn]');
    var priceBox = bar.querySelector('[data-ab-sticky-price]');
    var buttons = main.querySelector('.product-form__buttons');

    function setHidden(hidden) {
      bar.setAttribute('data-hidden', hidden ? 'true' : 'false');
      bar.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      /* 2026-10-19: bula WhatsApp urcă deasupra barei cât timp bara e vizibilă
         (snippets/abeauty-whatsapp.liquid), altfel acoperă prețul din bară. */
      document.documentElement.classList.toggle('ab-sticky-vizibil', !hidden);
      mutaIconitaCookie(!hidden);
    }

    /* Iconița apare abia după ce clientul alege în banner, deci reaplicăm starea la orice
       schimbare din shadow DOM-ul Consentmo (îl așteptăm până la 20 de secunde). */
    var incercari = 0;
    (function asteaptaConsentmo() {
      var host = document.querySelector('csm-cookie-consent');
      if (host && host.shadowRoot && window.MutationObserver) {
        var reaplica = function () {
          mutaIconitaCookie(bar.getAttribute('data-hidden') === 'false');
        };
        /* Și `style`: dacă Consentmo își rescrie poziția, o ridicăm din nou. Funcția nu scrie
           nimic când valoarea e deja cea corectă, deci nu intră în buclă. */
        new MutationObserver(reaplica).observe(host.shadowRoot, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['style'],
        });
        window.addEventListener('resize', reaplica);
        return;
      }
      if (++incercari < 20) setTimeout(asteaptaConsentmo, 1000);
    })();

    function refreshLabel() {
      var missing = incompleteSelect(main);
      if (btn) btn.textContent = missing ? labelFor(missing, submitButton(main)) : LABEL_BUY;
    }

    if (buttons && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          setHidden(e.isIntersecting);
        });
      }, { threshold: 0 });
      io.observe(buttons);
    } else {
      setHidden(false);
    }

    document.addEventListener('abeauty:selectie', function (e) {
      if (!e.detail || e.detail.scope !== main) return;
      if (btn) btn.textContent = e.detail.complete ? LABEL_BUY : (e.detail.label || LABEL_FALLBACK);
    });

    if (btn) {
      btn.addEventListener('click', function () {
        var missing = incompleteSelect(main);
        if (missing) {
          missing.focus();
          if (missing.scrollIntoView) missing.scrollIntoView({ block: 'center', behavior: 'smooth' });
          return;
        }
        var form = main.querySelector('form[data-type="add-to-cart-form"]');
        var submit = submitButton(main);
        if (!form || !submit || submit.hasAttribute('disabled')) {
          if (submit && submit.scrollIntoView) submit.scrollIntoView({ block: 'center', behavior: 'smooth' });
          return;
        }
        if (typeof form.requestSubmit === 'function') form.requestSubmit(submit);
        else submit.click();
      });
    }

    /* pretul urmareste varianta aleasa (Dawn publica variantChange dupa ce actualizeaza pagina) */
    /* `PUB_SUB_EVENTS` e declarat cu const in pubsub.js, deci NU e proprietate pe window; se citeste direct. */
    var evenimente = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null;
    if (priceBox && typeof subscribe === 'function' && evenimente && evenimente.variantChange) {
      subscribe(evenimente.variantChange, function (payload) {
        var v = payload && payload.data && payload.data.variant;
        if (!v || typeof v.price !== 'number') return;
        while (priceBox.firstChild) priceBox.removeChild(priceBox.firstChild);
        if (typeof v.compare_at_price === 'number' && v.compare_at_price > v.price) {
          var s = document.createElement('s');
          var eticheta = document.createElement('span');
          eticheta.className = 'visually-hidden';
          eticheta.textContent = 'preț vechi ';
          s.appendChild(eticheta);
          s.appendChild(document.createTextNode(formatLei(v.compare_at_price)));
          priceBox.appendChild(s);
          priceBox.appendChild(document.createTextNode('\u00a0'));
        }
        var strong = document.createElement('strong');
        strong.textContent = formatLei(v.price);
        priceBox.appendChild(strong);
      });
    }

    refreshLabel();
  }

  document.addEventListener('product-info:loaded', function (e) {
    if (e.target && e.target.tagName === 'PRODUCT-INFO') init(e.target);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); initSticky(); });
  } else {
    initAll();
    initSticky();
  }
})();
